const tabTriggers = document.querySelectorAll('.js-tab-trigger');

tabTriggers.forEach(function (tab, i) {

    const tabGroup = tab.closest('.js-tab-group');
    const groupTriggers = tabGroup.querySelectorAll('.js-tab-trigger');
    const groupContent = tabGroup.querySelectorAll('.js-tab-content');
    const colour = 'purple' ?? 'grey';

    tab.addEventListener("click", function() {
        const id = tab.dataset.id;

        groupTriggers.forEach(function (trigger, i) {
            trigger.classList.remove('!bg-' + colour);
            trigger.classList.remove('!text-' + colour + '-text');
        });
        groupContent.forEach(function (content, i) {
            if(content.dataset.id !== id) {
                content.classList.add('hidden');
            } else {
                content.classList.remove('hidden');
            }
        });
        tab.classList.add('!bg-' + colour);
        tab.classList.add('!text-' + colour + '-text');
        
    })

});